export interface UserLanguage {
  id: string | number;
  name: string;
  isoCode: string;
}

export const FEATURES = [
  'webapp',
  'user.management',
  'device.management',
  'translation.modify',
  'translation.admin',
  'documents.admin',
  'documents.read',
  'servicecontract.admin',
  'fieldSalesRepresentative.modify',
  'repairHistory.write',
  'superuser.forceLinkUser',
  'superuser.userLevelKeys',
] as const;
export type Feature = (typeof FEATURES)[number];
export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: User | null;
}

export interface User {
  id: string;
  email: string;
  name?: string;
  companyName?: string;
  language?: UserLanguage;
  companyUuid?: string;
  isCompanyAssigned?: boolean;
  canUseWebapp: boolean;
  features: Feature[];
  activeJoinRequest?: {
    id: string;
    companyName: string;
  };
}

export function hasFeature(user: User, feature: Feature): boolean {
  return user.features.includes(feature);
}
